import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

import MicIcon from "../../images/demo/main_section/mic_svg";
import LinkIcon from "../../images/demo/main_section/link_svg";
import DownloadIcon from "../../images/demo/download_svg";
import ResponseNew from "../Demo/ResponseNew";
import { CopyButton } from "./CopyButton";
import { toFarsiNumber } from "./utils";
import { DeleteButton } from "./DeleteButton";
import { AttachIcon } from "../../images";
import { deleteRequest, getRequestFromId, patchRequest } from "./data";
import { time_to_second } from "../Demo/utils/functions";
import { variant } from "../../animations";
import EditIcon from "../icons/edit-icon";
import CloseIcon from "../icons/close-icon";
import TickIcon from "../icons/tick-icon";
import DeleteIcon from "../icons/delete-icon";
import { errorNotify, successNotify } from "../notify/toastify";

const iconType = {
  Url: {
    icon: <LinkIcon />,
    color: "#FF1654",
  },
  Voice: {
    icon: <MicIcon />,
    color: "#40c6b8",
  },
  File: {
    icon: <AttachIcon />,
    color: "#118AD3",
  },
};

const Item = ({ data }) => {
  const [loadImage, setLoadImage] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [finalResponse, setFinalResponse] = useState(null);
  const [loadingResults, setLoadingResults] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const url = data.url;
  const fileExtension = url.split(".").pop();
  const fileName =
    data.filename === `.${fileExtension}` ||
    data.filename === "" ||
    data.filename == null ||
    data.filename == undefined
      ? url.split("/").pop()
      : data.filename.split(".").slice(0, -1).join(".");
  const [fileEdit, setFileEdit] = useState(fileName);
  const extension = data.filename
    ? data.filename.split(".").pop()
    : url.split(".").pop();
  const date = new Date(data.processed);
  const formattedDate = date.toLocaleDateString("fa-IR").split("/").join("-");
  const duration = toFarsiNumber(data.duration || "04:20:00");
  const type = "Url";
  const dialogRef = useRef(null);

  useEffect(() => {
    const clickHandle = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        closeModal();
        setFinalResponse(null);
      }
    };
    document.addEventListener("mousedown", clickHandle);
    return () => {
      document.removeEventListener("mousedown", clickHandle);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = async () => {
    setIsOpen(true);
    setLoadingResults(true);
    const response = await getRequestFromId({ id: data.id });

    if (response) {
      setFinalResponse({
        ...response,
        duration: time_to_second(response.duration),
      });
    }
    setLoadingResults(false);
  };

  const openEdit = () => {
    setIsEdit(true);
  };

  const closeEdit = () => {
    setIsEdit(false);
    setFileEdit(fileName);
  };

  const changeFilename = (e) => {
    setFileEdit(e.target.value);
  };

  const handleEdit = async () => {
    try {
      await patchRequest({
        id: data.id,
        filename: fileEdit,
        prefix: fileExtension,
      });
      setIsEdit(false);
      successNotify({ text: "با موفقیت ویرایش شد" });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      errorNotify({ text: error.detail });
    }
  };

  const openDelete = (e) => {
    e.stopPropagation();
    setIsDelete(true);
  };

  const closeDelete = () => {
    setIsDelete(false);
  };

  const handleDelete = async () => {
    try {
      await deleteRequest({ id: data.id });
      setIsDelete(false);
      successNotify({ text: "با موفقیت حذف شد" });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      errorNotify({ text: "مشکلی پیش آمده" });
    }
  };

  return (
    <>
      <motion.div
        variants={variant}
        initial="hidden"
        animate="visible"
        className="with-spacer"
      >
        <div className={`trow-wrapper`}>
          <div className="trow" style={{ alignItems: "center" }}>
            <div className="tbc justify-center" onClick={openModal}>
              <div
                style={!loadImage ? { display: "flex" } : { display: "none" }}
              >
                <button className="unstyled-btn"></button>
                <div
                  className="icon-wrapper"
                  style={
                    iconType[type] && {
                      "--color": iconType[type].color,
                    }
                  }
                >
                  {iconType[type]
                    ? iconType[type].icon
                    : iconType["Voice"].icon}
                </div>
              </div>
              <div
                className="item-top-thumbnail-container"
                style={
                  loadImage && !imageError
                    ? { display: "flex" }
                    : { display: "none" }
                }
              >
                <div className="item-top-thumbnail">
                  <img
                    alt=""
                    src={`/media_image/${url}`}
                    onLoad={() => setLoadImage(true)}
                    onError={() => setImageError(true)}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            </div>
            {!isEdit && (
              <>
                <div className="tbc" onClick={openModal}>
                  <button className="unstyled-btn"></button>
                  {fileName}
                </div>
                <div className="tbc" onClick={openModal}>
                  <button className="unstyled-btn"></button>
                  {formattedDate}
                </div>
                <div dir="ltr" lang="en" className="tbc" onClick={openModal}>
                  <button className="unstyled-btn"></button>
                  {extension}
                </div>
                <div className="tbc" onClick={openModal}>
                  <button className="unstyled-btn"></button>
                  {duration}
                </div>
                {!isDelete ? (
                  <div className="tbc actions">
                    <EditIcon
                      width={16}
                      height={16}
                      style={{ cursor: "pointer", marginTop: "0.5rem" }}
                      onClick={openEdit}
                    />
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-icon-wrapper"
                    >
                      <DownloadIcon />
                    </a>
                    <CopyButton requestId={data.id} />
                    <DeleteIcon
                      width={16}
                      height={16}
                      color="#8F8F8F"
                      onClick={(e) => openDelete(e)}
                      style={{ marginTop: "0.5rem", cursor: "pointer" }}
                    />
                  </div>
                ) : (
                  <div className="tbc actions">
                    <button
                      className="list-view-button"
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: "#E23D28",
                        width: "60px",
                        height: "29px",
                        border: "none",
                        borderRadius: "7px",
                      }}
                      onClick={handleDelete}
                    >
                      حذف
                    </button>
                    <button
                      className="list-view-button"
                      style={{
                        backgroundColor: "#FFFFFF",
                        color: "#727272",
                        width: "40px",
                        height: "29px",
                        border: "none",
                        borderRadius: "7px",
                      }}
                      onClick={closeDelete}
                    >
                      لغو
                    </button>
                  </div>
                )}
              </>
            )}
            {isEdit && (
              <>
                <div className="tbc">
                  <input
                    className="edit-input"
                    type="text"
                    onChange={(e) => changeFilename(e)}
                    value={fileEdit}
                    style={{ textOverflow: "ellipsis" }}
                  ></input>
                </div>
                <div className="tbc" style={{ color: "#8F8F8F" }}>
                  <button className="unstyled-btn"></button>
                  {formattedDate}
                </div>
                <div
                  dir="ltr"
                  lang="en"
                  className="tbc"
                  style={{ color: "#8F8F8F" }}
                >
                  <button className="unstyled-btn"></button>
                  {fileExtension}
                </div>
                <div className="tbc" style={{ color: "#8F8F8F" }}>
                  <button className="unstyled-btn"></button>
                  {duration}
                </div>
                <div className="tbc actions">
                  <TickIcon
                    width={16}
                    height={16}
                    style={{
                      cursor: "pointer",
                      marginTop: "0.1rem",
                      marginRight: "4.5rem",
                      marginLeft: "0.4rem",
                    }}
                    onClick={handleEdit}
                  />
                  <CloseIcon
                    height={16}
                    width={16}
                    color={"#939393"}
                    style={{ cursor: "pointer", marginTop: "0.1rem" }}
                    onClick={closeEdit}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="spacer"></div>
      </motion.div>
      <div className={clsx("modal", isOpen ? "modal-enter" : "modal-leave")}>
        <div
          className={clsx("dialog", isOpen ? "dialog-enter" : "dialog-leave")}
          dir="ltr"
          ref={dialogRef}
        >
          {finalResponse && (
            <ResponseNew finalResponse={finalResponse} isArchive={true} />
          )}
          {loadingResults && (
            <div className="response-new no-padding">
              <div className="atom-spinner">
                <div className="spinner-inner">
                  <div className="spinner-line"></div>
                  <div className="spinner-line"></div>
                  <div className="spinner-line"></div>
                  <div className="spinner-circle">&#9679;</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Item;
